export default __webpack_public_path__ + "static/media/maryland-department-of-general-service.82cd6d91.png";